import { useLanguage } from '@/contexts/LanguageContext';
import mercedesImg from '@/assets/mercedes-eclass.jpg?format=webp&quality=80';
import camryImg from '@/assets/toyota-camry.jpg?format=webp&quality=80';
import vitoImg from '@/assets/mercedes-vito.jpg?format=webp&quality=80';
import vclassImg from '@/assets/mercedes-vclass.jpg?format=webp&quality=80';
import teslaImg from '@/assets/tesla-models.jpg?format=webp&quality=80';
import passatImg from '@/assets/vw-passat.jpg?format=webp&quality=80';
import traficImg from '@/assets/renault-trafic.jpg?format=webp&quality=80';
import sprinterImg from '@/assets/mercedes-sprinter.jpg?format=webp&quality=80';
import { Users, Briefcase } from 'lucide-react';
import { motion } from 'framer-motion';

const FleetSection = () => {
  const { t } = useLanguage();

  const cars = [
    { name: 'Mercedes E-Class', img: mercedesImg, desc: t.fleet.mercedesDesc, passengers: 4, luggage: 4, tag: 'Business' },
    { name: 'Toyota Camry', img: camryImg, desc: t.fleet.camryDesc, passengers: 4, luggage: 3, tag: 'VIP' },
    { name: 'Tesla Model S', img: teslaImg, desc: t.fleet.teslaDesc, passengers: 4, luggage: 2, tag: 'Eco VIP' },
    { name: 'VW Passat', img: passatImg, desc: t.fleet.passatDesc, passengers: 4, luggage: 3, tag: 'Economy' },
    { name: 'Mercedes Vito', img: vitoImg, desc: t.fleet.vitoDesc, passengers: 8, luggage: 8, tag: 'Premium Van' },
    { name: 'Mercedes V-Klasse', img: vclassImg, desc: t.fleet.vclassDesc, passengers: 7, luggage: 7, tag: 'VIP Van' },
    { name: 'Renault Trafic', img: traficImg, desc: t.fleet.traficDesc, passengers: 8, luggage: 8, tag: 'Economy Van' },
    { name: 'Mercedes Sprinter', img: sprinterImg, desc: t.fleet.sprinterDesc, passengers: 16, luggage: 16, tag: 'Minibus' },
  ];

  return (
    <section id="fleet" className="py-20 md:py-28 bg-gradient-dark">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-secondary-foreground mb-4">{t.fleet.title}</h2>
          <p className="text-secondary-foreground/60 text-lg max-w-xl mx-auto">{t.fleet.subtitle}</p>
          <div className="w-16 h-1 bg-gradient-gold mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {cars.map((car, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="group bg-charcoal rounded-2xl overflow-hidden border border-primary/10 hover:border-primary/30 transition-all"
            >
              <div className="relative overflow-hidden">
                <img src={car.img} alt={`${car.name} – Taxi Salzburg ${car.tag} fleet vehicle for ${car.passengers} passengers`} className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <span className="absolute top-3 right-3 px-3 py-1 rounded-full bg-gradient-gold text-primary-foreground text-xs font-bold uppercase tracking-wider">
                  {car.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-bold text-secondary-foreground mb-2">{car.name}</h3>
                <p className="text-secondary-foreground/80 mb-4 text-sm line-clamp-3">{car.desc}</p>
                <div className="flex items-center gap-4 text-secondary-foreground/70 text-sm mb-4">
                  <span className="flex items-center gap-1.5"><Users className="w-4 h-4 text-primary" /> {car.passengers} {t.fleet.passengers}</span>
                  <span className="flex items-center gap-1.5"><Briefcase className="w-4 h-4 text-primary" /> {car.luggage} {t.fleet.luggage}</span>
                </div>
                <a href="#calculator" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-gold text-primary-foreground font-semibold hover:scale-105 transition-transform text-sm">
                  {t.fleet.bookNow}
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FleetSection;
